/**
 * 根据用户 IP 推断推荐语言（用于登录/注册页无缓存时的默认语言）
 * 映射规则：中国大陆/新加坡/马来西亚 → zh-CN，香港/澳门/台湾 → zh-HK，其他 → en
 */
const ZH_CN_COUNTRIES = ['CN', 'SG', 'MY'];
const ZH_HK_COUNTRIES = ['HK', 'TW', 'MO'];

export type GeoLanguage = 'zh-CN' | 'zh-HK' | 'en';

/**
 * 根据 IP 返回推荐语言
 * @returns zh-CN | zh-HK | en，失败时返回 zh-CN
 */
export async function getLanguageByIP(): Promise<GeoLanguage> {
  try {
    // 使用 ipapi.co（HTTPS、支持 CORS、无需 API Key）
    const res = await fetch('https://ipapi.co/json/', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      signal: AbortSignal.timeout(5000),
    });
    if (!res.ok) return 'zh-CN';
    const data = await res.json();
    const countryCode = (data?.country_code as string)?.toUpperCase?.() || '';
    if (ZH_CN_COUNTRIES.includes(countryCode)) return 'zh-CN';
    if (ZH_HK_COUNTRIES.includes(countryCode)) return 'zh-HK';
    return 'en';
  } catch {
    return 'zh-CN';
  }
}
